import { useState, useEffect } from 'react';
import './tmdb-item-suggestions.scss';
import { fetchTmdbMovieSuggestions, fetchTmdbSerieSuggestions } from '../../api/cap17drive-api';
import { getTmdbImage } from '../../../../utils/consts';
import { useNavigate } from 'react-router-dom';
import { Spinner } from '../../../shared';
import TmdbImage from '../../../shared/tmdb-image/tmdb-image';

const TmdbItemSuggestions = ({ item, isMovie }) => {

    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const method = isMovie ? fetchTmdbMovieSuggestions : fetchTmdbSerieSuggestions;

        if (item && item.id) {
            setLoading(true);
            method(item.id)
                .then(suggestions => {
                    setSuggestions(suggestions?.results || []);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [item, isMovie]);

    if(loading) {
        return <div className="tmdb-item-suggestions">
            <div className='d-flex flex-row justify-content-center'>
                <Spinner />
            </div>
            <div style={{
                textAlign: "center"
            }}>
                Recuperando sugerencias, por favor espere...
            </div>
        </div>;
    }

    return <div className="tmdb-item-suggestions">
        <div className="tmdb-item-suggestions__container">
            {suggestions.map(suggestion => (
                <button key={suggestion.id} className="tmdb-item-suggestions__item" onClick={() => {
                    if(suggestion.media_type === 'movie') {
                        navigate(`/squadflix/movies/${suggestion.id}`);
                    } else {
                        navigate(`/squadflix/series/${suggestion.id}`);
                    }
                }}>
                    <TmdbImage
                        className="tmdb-item-suggestions__item-still"
                        src={suggestion.backdrop_path}
                        size="w500"
                        alt={suggestion.title} />

                </button>
            ))}
            {suggestions.length % 3 === 2 && <div className="tmdb-item-suggestions__item"></div>}
        </div>
    </div>;
}

export default TmdbItemSuggestions;